import { render, staticRenderFns } from "./new_multiple_manipulated_orders_for_book.vue?vue&type=template&id=2ca214a8&scoped=true&lang=pug&"
import script from "./new_multiple_manipulated_orders_for_book.vue?vue&type=script&lang=js&"
export * from "./new_multiple_manipulated_orders_for_book.vue?vue&type=script&lang=js&"
import style0 from "./new_multiple_manipulated_orders_for_book.vue?vue&type=style&index=0&id=2ca214a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca214a8",
  null
  
)

export default component.exports